/** @format */
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, Output, ViewEncapsulation } from '@angular/core';
import { Attainment, DegreeProgramme, OtmId } from 'common-typescript/types';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { ModuleStateObject } from '../../service/plan-state.service';
import { Action, InputType } from '../../study-boxes/study-action-box/study-action-box.component';
import { StudyBoxType } from '../../study-boxes/study-box/study-box.component';
import { PlanStructureContext } from '../plan-structure-context';

@Component({
    selector: 'sis-plan-structure-degree-programme-box',
    templateUrl: './plan-structure-degree-programme-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureDegreeProgrammeBoxComponent {
    readonly module = input.required<DegreeProgramme>();
    readonly headingLevel = input.required<number>();
    readonly selected = input<boolean>();
    readonly action = input<Action>();
    readonly actionInputId = input<string>();
    readonly actionInputName = input<string>();
    readonly inputType = input<InputType>();
    readonly nameClickable = input<boolean>(true);
    @Output() actionChange? = new EventEmitter<OtmId>();

    boxType: StudyBoxType = StudyBoxType.degreeProgramme;
    planActionsService: PlanActionsService = inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN);
    private readonly planStructureContext = inject(PlanStructureContext);

    private readonly moduleStateObject = computed<ModuleStateObject | undefined>(
        () => this.planStructureContext.planStateObject().modules?.[this.module().id],
    );
    protected readonly attainment = computed<Attainment | undefined>(() => {
        const moduleStateObject = this.moduleStateObject();
        return moduleStateObject ? this.planStructureContext.planData().attainmentsById[moduleStateObject.attainmentId] : undefined;
    });
    protected readonly invalidSelection = computed(() => this.moduleStateObject()?.invalidSelectionWithoutApproval);
    protected readonly studyState = computed<'DRAFT' | 'DELETED' | undefined>(() => {
        const { documentState } = this.module();
        return documentState !== 'ACTIVE' ? documentState : undefined;
    });

    openDegreeProgrammeInfoModal() {
        this.planActionsService.openModuleInfoModal(this.module());
    }
}
